import { Box, Chip, Typography } from "@mui/material"
import type { FC } from "react"

import { ProductVersionChip } from "../../ProductVersionChip"

import DisplayIds from "@/components/common/DisplayIds/DisplayIds"
import { ComputedProductStatus, type Product, ProductVersionStatus } from "@/graphql/codegen/graphql"

interface SourceProductHeaderProps {
  product: Product
}

export const SourceProductHeader: FC<SourceProductHeaderProps> = ({ product }) => {
  const {
    companyProductDescription,
    publicId,
    externalSystemId,
    versionStatus,
    computedProductStatus,
    versions,
    versionId,
    company,
    countryOrigin,
  } = product

  const currentVersion = versions?.find((version) => version.id === versionId)
  const isActive = computedProductStatus === ComputedProductStatus.Active

  return (
    <Box className='p-6'>
      <Typography variant='overline' className='tracking-[1px] text-gray-700'>
        AKROCHEM DESCRIPTION
      </Typography>
      <Box className='flex items-center gap-3'>
        <Typography variant='h5' className='text-gray-800'>
          {companyProductDescription}
        </Typography>
        {versionStatus === ProductVersionStatus.Draft ? (
          <Chip label='Draft' variant='outlined' color='warning' />
        ) : (
          <Chip label={isActive ? "Active" : "Pending"} variant='outlined' color={isActive ? "success" : "warning"} />
        )}
        <ProductVersionChip version={currentVersion} />
        <DisplayIds entityName='Product ID' publicId={publicId} externalSystemId={externalSystemId} />
      </Box>
      <Box className='mt-6 flex items-center gap-6'>
        <Typography variant='body2' className='font-medium tracking-[0.46px] text-gray-700'>
          Supplier: {company?.name ?? "-"}
        </Typography>
        <Typography variant='body2' className='font-medium tracking-[0.46px] text-gray-700'>
          Origin: {countryOrigin?.country?.name ?? "-"}
        </Typography>
      </Box>
    </Box>
  )
}
